import { AfterViewInit, Component, ElementRef, OnInit, Renderer } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { Activate } from './activate.service';
import {UtilsService} from '../../shared/utils/utils.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'jhi-activate',
    templateUrl: './activate.component.html'
})
export class ActivateComponent implements OnInit, AfterViewInit {
    error: string;
    success: string;

    constructor(
        private activate: Activate,
        private route: ActivatedRoute,
        private elementRef: ElementRef, private renderer: Renderer,
        private router: Router,
        private utilsService: UtilsService,
        private titleService: Title
    ) {
    }

    ngOnInit () {
        this.route.queryParams.subscribe(params => {
            this.activate.get(params['key']).subscribe(() => {
                this.error = null;
                this.success = 'OK';
            }, () => {
                this.success = null;
                this.error = 'ERROR';
                this.titleService.setTitle('Echec de la création du compte');
            });
        });
        this.utilsService.setBckgrnd();
    }

    ngAfterViewInit() {
        if (this.elementRef.nativeElement.querySelector('#activateButton') != null) {
            this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#activateButton'), 'focus', []);
        }
    }

    login() {
        this.router.navigate(['/']);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/activate/activate.component.ts